import { useState, useMemo } from 'react';
import { List, useListContext, CreateButton, TopToolbar, useRedirect } from 'react-admin';
import { Box, Typography, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Chip } from '@mui/material';
import { tbl, btn, clickableA11y } from '../styles/ds';
import { useFitCount } from '../hooks/useFitCount';
import FitPagination from '../components/FitPagination';

const ROLE_HE = {
  admin: { label: 'מנהל/ת',  bg: 'rgba(200,169,110,0.25)', color: '#6b5322' },
  staff: { label: 'צוות',    bg: '#E2E3E5',                color: '#383D41' },
};

const fmtDate = iso => iso ? new Date(iso).toLocaleDateString('he-IL') : '—';

const Toolbar = () => (
  <TopToolbar>
    <CreateButton label="משתמש חדש" sx={btn.create} />
  </TopToolbar>
);

const UserTable = () => {
  const { data = [], isLoading } = useListContext();
  const redirect = useRedirect();
  const [page, setPage] = useState(1);
  const { fitCount, renderCount, containerRef, startIndex } = useFitCount({ fallback: 10, page });
  const pageItems = useMemo(() => {
    return data.slice(startIndex, startIndex + renderCount);
  }, [data, startIndex, renderCount]);

  if (isLoading) return null;

  return (
    <Box>
    <TableContainer component={Box} sx={{ ...tbl.container, border: '1px solid rgba(13,29,62,0.06)' }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: 60 }}>#</TableCell>
            <TableCell>שם משתמש</TableCell>
            <TableCell align="center">תפקיד</TableCell>
            <TableCell align="center">נוצר</TableCell>
          </TableRow>
        </TableHead>
        <TableBody ref={containerRef}>
          {pageItems.map((u, i) => {
            const role = ROLE_HE[u.role] || { label: u.role, bg: '#eee', color: '#333' };
            return (
              <TableRow key={u.id} onClick={() => redirect('edit', 'users', u.id)}
                {...clickableA11y(() => redirect('edit', 'users', u.id), { ariaLabel: `פתיחת משתמש ${u.username || ''}` })}
                sx={tbl.bodyRow(i)}>
                <TableCell><Typography fontWeight={600} color="text.secondary" fontSize={13}>#{u.id}</Typography></TableCell>
                <TableCell><Typography fontWeight={600} fontSize={14}>{u.username}</Typography></TableCell>
                <TableCell align="center">
                  <Chip label={role.label} size="small" sx={{ fontWeight: 700, fontSize: 11, backgroundColor: role.bg, color: role.color }} />
                </TableCell>
                <TableCell align="center"><Typography fontSize={13} color="text.secondary">{fmtDate(u.created_at)}</Typography></TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
    <FitPagination page={page} setPage={setPage} total={data.length} perPage={fitCount} />
    </Box>
  );
};

const UserList = () => (
  <List sort={{ field: 'id', order: 'ASC' }} perPage={1000} pagination={false} storeKey={false} actions={<Toolbar />} title="משתמשים" sx={tbl.listSx}>
    <UserTable />
  </List>
);

export default UserList;
